import { PageLoader } from '@diamond/shared/ui';
import { useFeatureFlagWithState } from '@diamond/shared/utils';
import { Navigate, Outlet } from 'react-router-dom';

interface FeatureFlagRouteProps {
  flagKey: string;
  defaultValue?: boolean;
  redirectTo?: string;
}

/**
 * A route guard that only renders its children when a feature flag is enabled.
 * Otherwise, redirects to the specified path (defaults to '/').
 */
export function FeatureFlagRoute({
  flagKey,
  defaultValue = false,
  redirectTo = '/',
}: FeatureFlagRouteProps) {
  const { value: isEnabled, loading } = useFeatureFlagWithState(
    flagKey,
    defaultValue
  );

  if (loading) {
    return <PageLoader />;
  }

  if (!isEnabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}
